import { LOCAL_COLORS } from 'styles/constants';
import { ProductHighlightsProps } from '../ProductHighlights';
import { StaticImage } from 'gatsby-plugin-image';

export const POP_REDESIGN_PRODUCT_HIGHLIGHTS_CONTENT: ProductHighlightsProps = {
  device: 'None',
  glyphs: [
    {
      name: 'Dermatologist-tested',
      glyph: (
        <StaticImage
          src="../images/dermatologist_glyph.png"
          alt="Dermatologist-tested icon"
        />
      ),
      textColor: LOCAL_COLORS.surfaceDarkBold,
    },
    {
      name: 'Non-comedogenic',
      glyph: (
        <StaticImage
          src="../images/non_comedogenic_glyph.png"
          alt="Non-comedogenic icon"
        />
      ),
      textColor: LOCAL_COLORS.surfaceDarkBold,
    },
    {
      name: 'Paraben-free',
      glyph: (
        <StaticImage
          src="../images/paraben_free_glyph.png"
          alt="Paraben free icon"
        />
      ),
      textColor: LOCAL_COLORS.surfaceDarkBold,
    },
    {
      name: 'Fragrance-free',
      glyph: (
        <StaticImage
          src="../images/fragrance_free_glyph.png"
          alt="Fragrance free icon"
        />
      ),
      textColor: LOCAL_COLORS.surfaceDarkBold,
    },
    {
      name: 'Sulfate-free',
      glyph: (
        <StaticImage
          src="../images/sulfate_free_glyph.png"
          alt="Sulfate free icon"
        />
      ),
      textColor: LOCAL_COLORS.surfaceDarkBold,
    },
    {
      name: 'Vegan',
      glyph: (
        <StaticImage
          src="../images/vegan_glyph.png"
          alt="Dermatologist-tested icon"
        />
      ),
      textColor: LOCAL_COLORS.surfaceDarkBold,
    },
    {
      name: 'Cruelty-free',
      glyph: (
        <StaticImage
          src="../images/cruelty_free_glyph.png"
          alt="Cruelty free icon"
        />
      ),
      textColor: LOCAL_COLORS.surfaceDarkBold,
    },
  ],
};
